import './ClassVerification.css';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSnackbar } from 'notistack';
import { Preferences } from '@capacitor/preferences';
import axios from 'axios';
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper';
import StandardButton from '../../components/StandardButton/StandardButton';
import StandardTextfield from '../../components/StandardTextfield/StandardTextfield';
import logo from "../../imgs/final_logo.png";

function ClassVerification() {
  const history = useHistory()
  const { pathname } = useLocation()
  const { enqueueSnackbar } = useSnackbar()

  const [verificationData, setVerificationData] = useState({ school_login_id: '', secret_code: '' })
  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    if (pathname == '/class-verification') setVerificationData({ school_login_id: '', secret_code: '' })

    return () => {
      setVerificationData({ school_login_id: '', secret_code: '' })
    }
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.values(verificationData)?.includes('')) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' });

    setBtnLoading(true);
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/schoollogin`, verificationData)
      .then(async res => {
        if (res.data.success) {
          await Preferences.set({ key: 'gjaai_user_schoolid', value: JSON.stringify(res.data.result[0].schoolid) })
          history.push("/signup");
          enqueueSnackbar('Verification Successful !!!', { variant: 'success' });
          setBtnLoading(false);
        } else {
          enqueueSnackbar(res.data.result, { variant: 'error' });
          setBtnLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setBtnLoading(false);
        enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
      })

  }

  return (
    <IonicPageWrapper headerTitle="School Login">
      <div id="class_verification">
        <section className="class_verification_cont">
          <form className="class_verification_form" onSubmit={handleSubmit}>
            <img src={logo} alt="Logo" className="login_logo" />

            <StandardTextfield
              label="Username"
              name="school_login_id"
              value={verificationData.school_login_id}
              setValue={setVerificationData}
              spreadValue={verificationData}
            />
            <StandardTextfield
              label="Passsword"
              name="secret_code"
              value={verificationData.secret_code}
              setValue={setVerificationData}
              spreadValue={verificationData}
            />

            <StandardButton label="Next" type="submit" loading={btnLoading} />
          </form>
        </section>
      </div>
    </IonicPageWrapper>
  );
}

export default ClassVerification